(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4576],{

/***/ 1967:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/[page]",
      function () {
        return __webpack_require__(7591);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4337);
/* harmony import */ var global_data__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6863);
/* harmony import */ var _UI_Layout_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6094);
/* harmony import */ var _UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5653);
/* harmony import */ var _UI_Primitives_Headings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7133);
/* harmony import */ var _UI_Icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9430);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5260);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 1.25rem 2rem 12rem;\n  background-color: #fafbfc;\n\n  @media (min-width: desktop) {\n    padding: 1.25rem 2rem 10rem;\n  }\n\n  a.trusted {\n    position: absolute;\n    bottom: -7rem;\n    left: 0;\n    width: 75px;\n    height: 75px;\n\n    @media (min-width: desktop) {\n      left: initial;\n      right: 26%;\n      top: 75%;\n      width: 100px;\n      height: 100px;\n    }\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n\n  a svg:hover {\n    fill: teal-200;\n  }\n\n  a:hover {\n    color: gray-200;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var FooterContainer = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].footer */ .ZPm.footer(_templateObject());
var LinkSection = function(param) {
    var heading = param.heading, start = param.start, end = param.end;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var theme = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_10__/* .useTheme */ .FgM)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xuv, {
        mb: 32,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Primitives_Headings__WEBPACK_IMPORTED_MODULE_6__/* .SectionTitle */ .NZ, {
                fontSize: theme.fontSizes.medium,
                children: heading
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                children: global_data__WEBPACK_IMPORTED_MODULE_3__/* .footerItems */ .q0["".concat(router.locale)].content.slice(start, end).map(function(item, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xuv, {
                        as: "li",
                        lineHeight: "2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: item.path === "blogi" ? "/blogi" : "/info/[page]",
                            as: item.path === "blogi" ? "/blogi" : "/info/".concat(item.path),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                "aria-label": item.title,
                                children: item.title
                            })
                        })
                    }, i);
                })
            })
        ]
    });
};
function Footer() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterContainer, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_UI_Layout_Container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
            display: {
                lg_tablet: "flex"
            },
            justifyContent: "space-between",
            pt: {
                _: 0,
                lg_tablet: 96
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xuv, {
                    as: "p",
                    maxW: {
                        _: 340,
                        lg_desktop: 400
                    },
                    color: "gray",
                    lineHeight: "1.75",
                    display: {
                        _: "none",
                        desktop: "block"
                    },
                    children: t("footer.footer_text")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xuv, {
                    display: {
                        lg_tablet: "grid"
                    },
                    gridTemplateColumns: "1fr 1fr",
                    columnGap: 64,
                    mr: {
                        desktop: 160
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LinkSection, {
                            heading: t("footer.heading1"),
                            start: 0,
                            end: 4
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LinkSection, {
                            heading: t("footer.heading2"),
                            start: 4,
                            end: 8
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xuv, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_5__/* .FlexBox */ .h, {
                                    spaceX: 16,
                                    my: 8,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "https://www.instagram.com/baltbaby",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            "aria-label": "Link to Baltbaby's Instagram",
                                            children: _UI_Icons__WEBPACK_IMPORTED_MODULE_7__/* .Instagram */ .mr
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "https://www.facebook.com/baltbaby",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            "aria-label": "Link to Baltbaby's Facebook",
                                            children: _UI_Icons__WEBPACK_IMPORTED_MODULE_7__/* .Facebook */ .s1
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_5__/* .FlexBox */ .h, {
                                    dir: "column",
                                    mt: 16,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "mailto:klienditeenindus@baltbaby.com",
                                            children: "klienditeenindus@baltbaby.com"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "tel:+37256988255",
                                            children: " +372 5698 8255"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "trusted",
                                    href: "https://www.e-kaubanduseliit.ee/liidust/usaldusmargisega-e-poed-eestis",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: "/images/turvaline_ostukoht_must.png",
                                        alt: "Label indicating the store is safe",
                                        layout: "fill"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 6464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@xstyled/styled-components/dist/styled-components.esm.js
var styled_components_esm = __webpack_require__(4337);
// EXTERNAL MODULE: ./node_modules/@xstyled/core/dist/core.esm.js
var core_esm = __webpack_require__(1278);
// EXTERNAL MODULE: ./components/Header/ContactInfo.js
var ContactInfo = __webpack_require__(5216);
// EXTERNAL MODULE: ./components/Header/Navbar/index.js + 17 modules
var Navbar = __webpack_require__(8173);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/getLinkPath.js
var getLinkPath = __webpack_require__(8776);
// EXTERNAL MODULE: ./components/UI/Primitives/FlexBox.js
var FlexBox = __webpack_require__(5653);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.js
var esm = __webpack_require__(1131);
// EXTERNAL MODULE: ./global/store.js
var store = __webpack_require__(561);
;// CONCATENATED MODULE: ./components/Header/Menus/CategoryMenu/Content.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n\n  &:not(:last-of-type) {\n    flex: auto;\n  }\n\n  a {\n    flex: 1;\n    padding-bottom: 1rem;\n    font-weight: 500;\n\n    &:hover,\n    &:active {\n      color: teal-400;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  min-height: 350px;\n  display: flex;\n  justify-content: space-between;\n  position: absolute;\n  top: 2.5rem;\n  left: 0;\n  padding: 3rem;\n  z-index: 3;\n  background-color: white;\n  box-shadow: 0px 0px 12px 2px rgba(247, 252, 254, 1);\n  border-radius: 0 0 30px 30px;\n\n  nav a {\n    font-size: small;\n    color: teal-300;\n    font-weight: 500;\n    line-height: 1.7;\n  }\n\n  nav > div a {\n    color: black;\n    font-size: 0.9rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var MenuItems = styled_components_esm/* default.div */.ZPm.div(_templateObject());
var SubMenu = styled_components_esm/* default.div */.ZPm.div(_templateObject1());
function Menu(param) {
    var category = param.category;
    var ref4;
    var ref1 = _slicedToArray((0,esm/* useAtom */.KO)(store/* currentPageAtom */.ef), 2), currentPage = ref1[0], setCurrentPage = ref1[1];
    var ref2 = (0,react.useState)(false), showMenu = ref2[0], setShowMenu = ref2[1];
    var categoryPath = category.name === "Blogi" ? "/blogi" : (0,getLinkPath/* default */.Z)(category.url_key);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItems, {
        onMouseEnter: function() {
            return category.name !== "Blogi" && category.name !== "Kinkekaart" && category.children.length !== 0 && setShowMenu(true);
        },
        onMouseLeave: function() {
            return setShowMenu(false);
        },
        onClick: function() {
            return setShowMenu(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: categoryPath,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: function(e) {
                        setCurrentPage(1);
                    },
                    children: category.name
                })
            }),
            showMenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubMenu, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexBox */.h, {
                        display: "grid",
                        gridTemplateColumns: "repeat(3, 1fr)",
                        columnGap: "3rem",
                        children: (ref4 = category.children) === null || ref4 === void 0 ? void 0 : ref4.map(function(parent) {
                            var ref, ref3;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                children: [
                                    ((ref = parent.products) === null || ref === void 0 ? void 0 : ref.total_count) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: (0,getLinkPath/* default */.Z)(parent.url_key, category.url_key),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: parent.name
                                        })
                                    }),
                                    parent === null || parent === void 0 ? void 0 : (ref3 = parent.children) === null || ref3 === void 0 ? void 0 : ref3.map(function(child) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: child.product_count >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: (0,getLinkPath/* default */.Z)(child.url_key, parent.url_key, category.url_key),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        onClick: function(e) {
                                                            setCurrentPage(1);
                                                        },
                                                        children: child.name
                                                    })
                                                })
                                            }, child.url_key)
                                        });
                                    })
                                ]
                            }, parent.url_key);
                        })
                    }),
                    (category === null || category === void 0 ? void 0 : category.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: category === null || category === void 0 ? void 0 : category.image,
                        alt: category.name,
                        width: 152.5,
                        height: 267
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/UI/Primitives/ClientOnly.js
var ClientOnly = __webpack_require__(1028);
// EXTERNAL MODULE: ./components/UI/Layout/Container.js
var Container = __webpack_require__(6094);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 68 modules
var dist_esm = __webpack_require__(5260);
;// CONCATENATED MODULE: ./components/Header/Menus/CategoryMenu/index.js








function CategoryMenu_Menu(param) {
    var categories = param.categories;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientOnly/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            mb: "1rem",
            display: {
                _: "none",
                desktop: "block"
            },
            children: categories && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                as: "nav",
                justify: "space-between",
                whiteSpace: "nowrap",
                children: [
                    categories === null || categories === void 0 ? void 0 : categories.map(function(category) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
                            category: category
                        }, category.name);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/brands",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                            as: "a",
                            ml: 50,
                            fontWeight: 500,
                            hoverColor: "teal-400",
                            activeColor: "teal-400",
                            children: t("header.brands")
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./components/Search/SearchBar.js + 3 modules
var SearchBar = __webpack_require__(8314);
;// CONCATENATED MODULE: ./components/Header/index.js









// import { CompareLarge } from '@/UI/Button/Compare';
function Header(param) {
    var categories = param.categories, isSearchPage = param.isSearchPage;
    var theme = (0,styled_components_esm/* useTheme */.FgM)();
    var width = (0,core_esm/* useViewportWidth */.jK)();
    var router = (0,next_router.useRouter)();
    var path = router.pathname;
    var ref = (0,react.useState)(theme.colors["blue-100"]), bg = ref[0], setBg = ref[1];
    (0,react.useEffect)(function() {
        if (!(width >= 1024 && (path === "/" || path === "/brands/[brand]" || path === "/kvartal"))) {
            setBg(theme.colors.white);
        }
    }, [
        path,
        width,
        theme.colors
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_esm/* Box */.xuv, {
        as: "header",
        bg: bg,
        p: {
            _: "1.25rem 1rem 0 1rem",
            desktop: "6rem 2rem 2rem"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactInfo/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexColCenter */.S, {
                display: {
                    _: "flex",
                    desktop: "none"
                },
                spaceY: "1rem",
                mb: "2rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar/* default */.Z, {
                    isSearchPage: isSearchPage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryMenu_Menu, {
                categories: categories
            })
        ]
    });
};


/***/ }),

/***/ 3793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Layout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6464);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);



function Layout(param) {
    var children = param.children, categories = param.categories, isSearchPage = param.isSearchPage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                categories: categories,
                isSearchPage: isSearchPage
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};


/***/ }),

/***/ 7591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ InfoPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var interweave__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3108);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4337);
/* harmony import */ var graphql_apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5865);
/* harmony import */ var _SEO__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9831);
/* harmony import */ var _UI_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3793);
/* harmony import */ var _UI_Layout_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6094);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  h2,\n  p,\n  a,\n  b,\n  span {\n    font-size: small;\n\n    @media (max-width: desktop) {\n      font-size: xsmall;\n    }\n  }\n\n  h2 {\n    line-height: 2;\n    max-width: 1200px;\n  }\n\n  p {\n    line-height: 1.75;\n    margin-bottom: 2rem;\n  }\n\n  span {\n    font-weight: 300;\n  }\n\n  a {\n    font-weight: 500;\n    text-decoration: underline;\n  }\n\n  @media (max-width: desktop) {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var PageContainer = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .ZPm.div(_templateObject());
var __N_SSG = true;
function InfoPage(param) {
    var title = param.title, content = param.content, categories = param.categories;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_UI_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        categories: categories,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SEO__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                seo: {
                    title: "".concat(title, " - Baltbaby")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Layout_Container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
                mb: 160,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PageContainer, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xuv, {
                            as: "h1",
                            fontSize: {
                                _: "large",
                                desktop: "xxxlarge"
                            },
                            m: "1rem 0 3rem",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(interweave__WEBPACK_IMPORTED_MODULE_6__/* .Markup */ .Lu, {
                            content: content,
                            blockList: [
                                "div"
                            ],
                            noWrap: true
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 8776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getLinkPath; }
/* harmony export */ });
function getLinkPath(urlKey, parent, grandparent) {
    var path = "/kataloog/".concat(grandparent ? grandparent + "/" : "").concat(parent ? parent + "/" : "").concat(urlKey);
    return path;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4337,1664,7536,9669,5675,3305,3108,2483,5275,1979,9774,2888,179], function() { return __webpack_exec__(1967); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);